<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-26 17:12:10
 * @Description: 观测时报--覆盖率模块
 -->
<template>
  <div class="observe-cover" >
    <cover-map></cover-map>
    <cover-table></cover-table>
  </div>
</template>

<script>
import CoverMap from './cover-map'
import CoverTable from './cover-table'

export default {
  components: {
    CoverMap,
    CoverTable,
  },
}
</script>

<style lang="scss">
</style>
